import { QUOTES_TYPE, quotesTypeFullName } from "../types/index.const";

const quotesRender = QUOTES_TYPE.map((el, index) => ({
  value: el,
  label: quotesTypeFullName[index],
}));

export default quotesRender;
